export interface MeteorShower {
  id: string;
  name: string;
  peakDate: string; // YYYY-MM-DD
  peakLabel: string; // e.g. "Aug 12–13"
  activityWindow: string; // e.g. "Jul 17 – Aug 24"
  zhr: string; // zenithal hourly rate
  note?: string;
}

// Curated meteor showers (peak dates adjusted per year; here 2025–2026)
export const METEOR_SHOWERS: MeteorShower[] = [
  {
    id: 'quadrantids',
    name: 'Quadrantids',
    peakDate: '2026-01-03',
    peakLabel: 'Jan 3–4',
    activityWindow: 'Dec 28 – Jan 12',
    zhr: '120',
    note: 'Short peak; best after midnight',
  },
  {
    id: 'lyrids',
    name: 'Lyrids',
    peakDate: '2026-04-22',
    peakLabel: 'Apr 22–23',
    activityWindow: 'Apr 16 – Apr 25',
    zhr: '18',
  },
  {
    id: 'eta-aquariids',
    name: 'η-Aquariids',
    peakDate: '2026-05-05',
    peakLabel: 'May 5–6',
    activityWindow: 'Apr 19 – May 28',
    zhr: '50',
    note: 'Best from Southern Hemisphere',
  },
  {
    id: 'perseids',
    name: 'Perseids',
    peakDate: '2026-08-12',
    peakLabel: 'Aug 12–13',
    activityWindow: 'Jul 17 – Aug 24',
    zhr: '100',
    note: 'Summer classic',
  },
  {
    id: 'orionids',
    name: 'Orionids',
    peakDate: '2026-10-21',
    peakLabel: 'Oct 20–21',
    activityWindow: 'Oct 2 – Nov 7',
    zhr: '20',
  },
  {
    id: 'leonids',
    name: 'Leonids',
    peakDate: '2026-11-17',
    peakLabel: 'Nov 17–18',
    activityWindow: 'Nov 6 – Nov 30',
    zhr: '15',
  },
  {
    id: 'geminids',
    name: 'Geminids',
    peakDate: '2026-12-14',
    peakLabel: 'Dec 13–14',
    activityWindow: 'Dec 4 – Dec 17',
    zhr: '150',
    note: 'Best display of the year',
  },
  {
    id: 'ursids',
    name: 'Ursids',
    peakDate: '2026-12-22',
    peakLabel: 'Dec 22–23',
    activityWindow: 'Dec 17 – Dec 26',
    zhr: '10',
  },
];

export function getUpcomingMeteorShowers(limit = 5): MeteorShower[] {
  const now = new Date().toISOString().slice(0, 10);
  return METEOR_SHOWERS.filter((m) => m.peakDate >= now).slice(0, limit);
}
